import { Size, type StatusResolver } from '@bms2/shared';
import { Pill } from './Pill';
import styles from './Pill.module.css';

/**
 * StatusPill (piece 3, decision 0098): a wrapper that resolves a status value
 * to its label and colour group through the seeded StatusDefinition rows for
 * the enum the field is typed as, via an injected resolver. It never resolves
 * through a shared global enum or a hardcoded map, and a value with no row
 * renders no label rather than an invented one.
 */
export interface StatusPillProps {
  /** The name of the enum the field is typed as, such as PersonStatus. */
  entityType: string;
  statusValue: string;
  resolve: StatusResolver;
  size?: Size;
}

export const statusPillDocumentedStates = ['good', 'warning', 'error', 'inactive', 'unresolved'] as const;

export function StatusPill({ entityType, statusValue, resolve, size = Size.Medium }: StatusPillProps) {
  const resolved = resolve(entityType, statusValue);
  if (!resolved) {
    return <span className={`${styles.pill} ${styles.medium} ${styles.unresolved}`} data-status-unresolved={`${entityType}.${statusValue}`} />;
  }
  return (
    <span data-status-pill={resolved.colorGroup} data-status-value={statusValue}>
      <Pill text={resolved.label} foreground={`var(--status-${resolved.colorGroup}-text)`} background={`var(--status-${resolved.colorGroup}-bg)`} size={size} />
    </span>
  );
}
